import { select } from '@panel/commons/core/themev2';
import { isMobileDevice } from '@panel/commons/helpers';
import { useModal } from '@panel/commons/hooks';
import React from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { useStepperCtx } from '../stepper';
import { ProgressBoxItem } from './progressboxitem';
import { Modal } from '../Modals/ModalWrapper';
import { SaveChangeForm } from '../Modals/saveChangeForm';
import { LeavePaymentForm } from '../Modals/leavePaymentForm';
import { isPaymentScreen } from '../../utils/path';

const Container = styled.div`
  max-width: 290px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 8px;
  background-color: ${select('lightGray')};
  border-radius: 15px;
  font-family: 'Hind';
  margin-bottom: 20px;
`;

const ProgressBox = React.memo(function MemoProgressBox({ modules = [] }) {
  const { isShowing, toggleValue } = useModal();
  const { push } = useHistory();
  const {
    preventTransition,
    stepperFormRef,
    setNextStepperRoute,
    setPreventTransition,
    nextStepperRoute
  } = useStepperCtx();
  const isMobile = isMobileDevice();
  const location = useLocation();

  const handleRedirect = path => {
    const idPost = new URLSearchParams(location.search).get('postingId');
    push(`${path}${idPost ? `?postingId=${idPost}` : ''}`);
  };

  const handleModalClose = () => {
    toggleValue(false);
  };

  const handleModalRedirect = () => {
    handleModalClose();
    setPreventTransition(null);
    handleRedirect(nextStepperRoute);
  };

  const handleOpenModal = path => {
    setNextStepperRoute(path);
    toggleValue(true);
  };

  return (
    <Container>
      {!isMobile && (
        <>
          {modules &&
            modules.map(({ id, title, path, stepName, enablingStep, enablingModule }) => (
              <ProgressBoxItem
                key={id}
                id={id}
                stepName={stepName}
                title={title}
                path={path}
                enablingStep={enablingStep}
                enablingModule={enablingModule}
                preventTransition={preventTransition}
                handleOpenModal={handleOpenModal}
              />
            ))}
          {isShowing && !isPaymentScreen(location.pathname) && (
            <Modal>
              <SaveChangeForm
                openModal={isShowing}
                onClose={handleModalClose}
                handleRedirect={handleModalRedirect}
                formRef={stepperFormRef}
              />
            </Modal>
          )}
          {isShowing && isPaymentScreen(location.pathname) && (
            <Modal>
              <LeavePaymentForm openModal={isShowing} onClose={handleModalClose} handleRedirect={handleModalRedirect} />
            </Modal>
          )}
        </>
      )}
    </Container>
  );
});

export { ProgressBox };
